import { styled } from 'styled-components';

export const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.light.color};
  padding: 1.2rem 0.8rem;
  border-radius: 10px;
  max-width: 100%;
  width: 100%;
  margin-bottom: 1rem;

  p {
    color: ${({ theme }) => theme.colors.primary.color};
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.125rem;
    margin: 0;
  }

  &::after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 1rem 0.6rem 0;
    border-color: ${({ theme }) => theme.colors.light.color} transparent;
    bottom: -1rem;
    right: 1rem;
    transform: translateX(-50%);
  }
`;
